import React from 'react'
import {Table, Input, InputGroup, InputGroupAddon, Button} from 'reactstrap'
import Loader from 'react-loader-spinner'
import SortAscendingIcon from 'react-icons/lib/fa/sort-asc'
import SortDescendingIcon from 'react-icons/lib/fa/sort-desc'
import WarningIcon from 'react-icons/lib/fa/exclamation-triangle'
import {ControllerListTableRow} from "./"
import SearchIcon from 'react-icons/lib/fa/search'
import ClearIcon from 'react-icons/lib/fa/close'


let ControllerListTable = ({controllers, archivedOnlySelection, compact, highlightedID, deletearchivecontrollers, sortByField, showTeams, loadingControllers, sortBy, sortDescending,
                               onRowMouseOver, onRowMouseOut,clearSearch, onRowClick, onSortClick, selectable, actionName, onSelectedChange, selectedControllers,phone, handleInput1Change}) =>
                               
                            <div>
                                <InputGroup>
                                <Input id="searchname" onKeyPress={(event) => {
                        if (event.key === 'Enter') {
                            onSortClick( event,"searchbyname")
                        } else{
                            
                        }}} placeholder = "Search by Name or Phone or Field" onChange={handleInput1Change} value ={phone}/>
                                {phone && phone.length ?
                                <InputGroupAddon addonType="append">
                                    <Button color="danger" onClick={clearSearch}>
                                        <ClearIcon/>
                                    </Button>
                                </InputGroupAddon> :
                                null}
                                <Button color="secondary" onClick={(event) => 
                                onSortClick( event,"searchbyname")
                                }>
                                <SearchIcon/>
                                </Button>
                               </InputGroup> 
                      
                               

                                    
    <Table className="controller-table">

        <thead>
        <tr>
        {selectable ?
            <td className="action-head" width="100">
                <small className={selectedControllers.length > 0 ? "font-weight-bold" : ""}>
                    {actionName} ({selectedControllers.length})
                </small>
            </td> :
            null}
            <th className="status-col" onClick={(event) => onSortClick(event, "status")}>
                <small className={(sortBy === "status" ? "font-weight-bold sf-blue" : "")}>
                    {sortBy === "status" ? (sortDescending ? <SortDescendingIcon className="sort-desc"/> :
                        <SortAscendingIcon className="sort-asc"/>) : null}
                    Status
                </small>
            </th>
            <th onClick={(event) => onSortClick(event, "name")}>
                <small className={(sortBy === "name" ? "font-weight-bold sf-blue" : "")}>
                    {sortBy === "name" ? (sortDescending ? <SortDescendingIcon className="sort-desc"/> :
                        <SortAscendingIcon className="sort-asc"/>) : null}
                    Name
                </small>
            </th>
            {showTeams ?
                <th onClick={(event) => onSortClick(event, "team")}>
                    <small className={(sortBy === "team" ? "font-weight-bold sf-blue" : "")}>
                        {sortBy === "team" ? (sortDescending ? <SortDescendingIcon className="sort-desc"/> :
                            <SortAscendingIcon className="sort-asc"/>) : null}
                        Team
                    </small>
                </th> :
                null}
            {!compact ? <th onClick={(event) => onSortClick(event, "field")} className="d-none d-md-table-cell">
                <small className={(sortBy === "field" ? "font-weight-bold sf-blue" : "")}>
                    {sortBy === "field" ? (sortDescending ? <SortDescendingIcon className="sort-desc"/> :
                        <SortAscendingIcon className="sort-asc"/>) : null}
                    Field
                </small>
            </th> : null}
            {!compact ? <th onClick={(event) => onSortClick(event, "flowRate")} className="d-none d-md-table-cell">
                <small className={(sortBy === "flowRate" ? "font-weight-bold sf-blue" : "")}>
                    {sortBy === "flowRate" ? (sortDescending ? <SortDescendingIcon className="sort-desc"/> :
                        <SortAscendingIcon className="sort-asc"/>) : null}
                    Flow Rate
                </small>
            </th> : null}
            {!compact ? <th onClick={(event) => onSortClick(event, "tankLevel")} className="d-none d-lg-table-cell">
                <small className={(sortBy === "tankLevel" ? "font-weight-bold sf-blue" : "")}>
                    {sortBy === "tankLevel" ? (sortDescending ? <SortDescendingIcon className="sort-desc"/> :
                        <SortAscendingIcon className="sort-asc"/>) : null}
                    Tank Level
                </small>
            </th> : null}
            <th onClick={(event) => onSortClick(event, "connectionStrength")} className="d-none d-lg-table-cell">
                <small className={(sortBy === "connectionStrength" ? "font-weight-bold sf-blue" : "")}>
                    {sortBy === "connectionStrength" ? (sortDescending ? <SortDescendingIcon className="sort-desc"/> :
                        <SortAscendingIcon className="sort-asc"/>) : null}
                    Connectivity
                </small>
            </th>
        </tr>
        </thead>
        <tbody>
        {loadingControllers ?
            <tr>
                <td colSpan={20} align="center" valign="middle">
                    <Loader type="TailSpin" color="orange" width={60} height={60}/>
                </td>
            </tr> :
            (controllers.length ?
                controllers.map((con, idx) =>
                    <ControllerListTableRow key={`controller-row-${idx}-${con.id}-${con.userIdentifiableName}`}
                                            controller={con}
                                            archivedOnlySelection={archivedOnlySelection}
                                            compact={compact}
                                            deletearchivecontrollers={deletearchivecontrollers}
                                            sortByField={sortByField}
                                            highlighted={con.id === highlightedID}
                                            showTeam={showTeams}
                                            onMouseOver={onRowMouseOver}
                                            onMouseOut={onRowMouseOut}
                                            onClick={onRowClick}
                                            sortBy={sortBy}
                                            selectable={selectable}
                                            selectedControllers={selectedControllers}
                                            onSelectedChange={onSelectedChange}/>):
                        <tr>
                            <td colSpan={20} align="center" valign="middle" className="font-weight-bold text-secondary">
                                <WarningIcon className="mr-2"/>No Controllers Available.
                            </td>
                        </tr>)}


        {loadingControllers ?
            <tr>
                <td className="invisible">Status</td>
                <td className="invisible">Controller Name & Serial</td>
                {showTeams ?
                    <td className="invisible">Team Name</td> :
                    null}
                {!compact ? <td className="invisible">Field Name</td> : null}
                {!compact ? <td className="invisible">Flow Rate</td> : null}
                {!compact ? <td className="invisible">Tank Level</td> : null}
                <td className="invisible">Conn</td>
            </tr> :
            null}
        </tbody>
    </Table>
    </div>

export default ControllerListTable



// WEBPACK FOOTER //
// ./src/components/ui/ControllerListTable.js